/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getExposure } from '../selectors';
import { loadExposure, computeExposure, retrieveExposureCurrencies } from '../actionCreators';
import ExposureCard from './ExposureCard';

const ExposureContainer = ({ documentId, siteId, actions, exposure }) => {
  const [computing, setComputing] = useState(false);
  const [localExposure, setLocalExposure] = useState({ loading: true, loaded: false });
  const [selectedCurrency, setSelectedCurrency] = useState();

  useEffect(() => {
    actions.loadExposure(documentId, siteId);
  }, []);

  useEffect(() => {
    actions.loadExposure(documentId, siteId);
  }, [documentId, siteId, exposure.loaded]);

  useEffect(() => {
    if (!localExposure || (!localExposure.loading && !!localExposure.loaded)) {
      actions.retrieveExposureCurrencies(documentId, siteId);
    }
  }, [localExposure.loaded, localExposure.loading]);

  useEffect(() => {
    if (Array.isArray(localExposure.exposureCurrencies) && localExposure.exposureCurrencies.length) {
      const defaultCurrency = localExposure.exposureCurrencies.find(({ isDefault }) => isDefault === true);
      setSelectedCurrency(defaultCurrency);
    }
  }, [localExposure.exposureCurrencies]);

  useEffect(() => {
    if (!exposure.loading && !!exposure.loaded) {
      setLocalExposure(exposure);
    }
  }, [exposure.loaded, exposure.loading]);

  const onCompute = () => {
    setComputing(true);
    actions.computeExposure(documentId, siteId).then(() => {
      setComputing(false);
    });
  };

  const onCurrencyChange = currency => {
    setSelectedCurrency(currency);
  };

  return (
    <ExposureCard
      exposure={localExposure}
      computing={computing}
      onCompute={onCompute}
      onCurrencyChange={onCurrencyChange}
      selectedCurrency={selectedCurrency}
      exposureCurrencies={localExposure.exposureCurrencies}
    />
  );
};

ExposureContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  exposure: PropTypes.object.isRequired
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  return {
    exposure: getExposure(state, key)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadExposure,
        computeExposure,
        retrieveExposureCurrencies
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ExposureContainer);
